<template>
  <div class="box-writing" style="cursor: pointer" @click="boxClick(info)">
    <div class="bac-box">
      <img
        :class="props.info.img_type === 2 ? 'bigwidth1' : ''"
        width="173px"
        v-complete:src="props.info.img_url"
        alt=""
      />
    </div>
    <div class="content-box">
      <p>{{ props.info.title }}</p>
      <div></div>
      <section class="section-box">
        <p>
          <span :style="{ color: props.leftColor }">学科：</span>
          <span v-for="(item, index) in props.info.apply_subject" :key="index" style="color:#333;margin-right:2px;">
            {{ item }}
          </span>
        </p>
        <p>
          <span :style="{ color: props.leftColor }">适用年级：</span
          >{{ props.info.grade }}
        </p>
        <p>
          <span :style="{ color: props.leftColor }">适用地区：</span>
          <span
            style="color: #333333"
            v-for="(item, index) in props.info.apply_area"
            :key="index"
          >
            {{ item.city_name }}
          </span>
        </p>
      </section>
      <p>
        <el-icon><Aim /></el-icon>
        <!-- <span>{{
          props.info.description ? props.info.description : props.info.title
        }}</span> -->
        <span
         style="color:#666666"
          v-html="
            props.info.description
              ? props.info.description.replace(/\n/gi, '<br>')
              : props.info.title
          "
        ></span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { Aim } from "@element-plus/icons-vue";

import { useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  leftColor: {
    type: String,
    default: "#007ad8",
  },
});

function boxClick(val) {
  if (!val.outPage) {
    router.push({
      path: "/layout/list/booksDetails",
      query: { id: val.id },
    });
  } else {
    if (val.path) {
      window.open(val.path);
    }
  }
}
</script>

<style scoped lang="scss">
.box-writing {
  // border:1px solid red;
  // width: 520px;
  // height: 182px;
  display: flex;
  .bac-box {
    // border:1px solid rgb(0, 47, 255);
    width: 120px;
    height: 120px;
    // background-color: transparent;
    border-radius: 8px;
    background: linear-gradient(
      110.6deg,
      #eceeed 17.12%,
      #f6f8f7 52.8%,
      #edefee 90.74%
    );
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      width: 75px;
      // min-height: 237px;
      margin: 0px;
      border-radius: 0px;
    }
  }
  // justify-content: space-between;
  // > .bac-box {
  //   width: 230px;
  //   height: 230px;
  //   border-radius: 8px;
  //   background: linear-gradient(
  //     110.6deg,
  //     #eceeed 17.12%,
  //     #f6f8f7 52.8%,
  //     #edefee 90.74%

  //   );
  //    >img{
  //       margin-left:52px;
  //       margin-top:40px;
  //     }
  // }
  > .content-box {
    width: 178px;
    // border:1px solid rgb(89, 0, 255);
    margin-left: 13px;
    

    > p:nth-of-type(1) {
      // border:1px solid red;
      // width:287px;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      color: #333333;

      line-height: 24px;
      white-space: nowrap !important; //不折行
      text-overflow: ellipsis !important; //文本溢出 用省略号显示
      overflow: hidden;
    }
    > p:nth-of-type(2) {
      // width:360px;
      font-size: 14px;
      // font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      position: relative;
      // position: absolute;
      // left: 20px;

      text-align: justify;
      line-height: 25px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;
      // display:flex;
      // align-items: center;
      // border:1px solid red;
      > span {
        margin-left: 20px;
      }
    }
    :deep(.el-icon) {
      font-size: 16px;
      color: #009de0;
      position: absolute;
      top: 3px;
    }
    // > p:nth-of-type(2)::before {
    //   content: ""; /* 添加的内容 */
    //   display: block;
    //   width: 13px;
    //   height: 13px;
    //   border: 1px solid #009de0;
    //   border-radius: 50%;
    //   position: absolute;
    //   top: 3px;
    //   left: -20px;
    //   // //  transform: translateX(-50%); /* 水平居中偏移修正 */
    // }
    > div {
      border: 1px dashed #cccccc;
      margin-top: 6px;
      margin-bottom: 6px;
    }

    >p:hover{
      color:#009de0;
      >span:hover{
        color:#009de0 !important;
      }
    }
  }
}
.section-box {
  // border: 1px solid red;
  > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    margin: 8px 0;
    height: auto !important;
    color: #333333;
    > span {
      color: #007ad8;
    }
  }
}
</style>
